import { updateSlatesGQLMutation } from '../../graphql/index.js';
export class SlatesClient {
    constructor(client) {
        this.client = client;
    }
    async update(variables, fields = 'all', accessToken) {
        const result = await this.client.authorizedRequest({
            query: updateSlatesGQLMutation(fields),
            variables,
            customToken: accessToken,
        });
        return result.updateSlates;
    }
}
//# sourceMappingURL=slates.client.js.map